module.exports = __webpack_public_path__ + "img/tips.60140396.png";